import React from "react";

/**
 * Net worked time for one attendance row, shared by the History and member-profile tables.
 *
 * When the day fell SHORT of the member's required hours it renders as a pink pill, styled
 * like the dashboard's "Actual hrs" cell, so an admin can spot undertime days by scanning
 * the column. `shortfallSeconds` is computed on the server by rowShortfallSeconds — the
 * same rule behind the History "Work Shortfall" KPI — so a pink row and that total can
 * never disagree. It is 0 for complete days, absences, and still-running sessions.
 */
// "1h 40m" / "45m" — shared with the dashboard's Actual-hrs pill so all three tables word
// the undertime tooltip identically.
export const fmtShortfall = (sec) => {
  const h = Math.floor(sec / 3600);
  const m = Math.round((sec % 3600) / 60);
  return h ? (m ? `${h}h ${m}m` : `${h}h`) : `${m}m`;
};

// Info icon + hover title, mirroring the overnight-shift marker on the Check-out cell.
export const ShortfallTip = ({ seconds }) => (
  <span
    className="ovn-tip tip-short"
    title={`Work shortfall — ${fmtShortfall(seconds)} short of the required hours`}
  >
    <svg><use href="#i-info" /></svg>
  </span>
);

const HoursCell = ({ log, hoursStr }) => {
  const short = Number(log?.shortfallSeconds) || 0;
  if (short <= 0) return <>{hoursStr}</>;
  return (
    <>
      <span className="pill-actual pill-short">{hoursStr}</span>
      <ShortfallTip seconds={short} />
    </>
  );
};

export default HoursCell;
